import React from 'react';

import { MILITARY, MILITARY_FOREIGN } from 'config/formSections/military';
import { i18n } from 'config/locales';

import Subsection from 'components/Section/shared/Subsection';
import connectSubsection from 'components/Section/shared/SubsectionConnector';

import ForeignService from 'components/Section/Military/Foreign/ForeignService';
import BranchCollection from 'components/Form/BranchCollection';
import Comments from 'components/Form/Comments';

const sectionConfig = {
  key: MILITARY_FOREIGN.key,
  section: MILITARY.name,
  store: MILITARY.store,
  subsection: MILITARY_FOREIGN.name,
  storeKey: MILITARY_FOREIGN.storeKey,
};

export class Foreign extends Subsection {
  constructor(props) {
    super(props);

    const {
      section, subsection, store, storeKey
    } = sectionConfig;

    this.section = section;
    this.subsection = subsection;
    this.store = store;
    this.storeKey = storeKey;
    this.update = this.update.bind(this);
    this.updateList = this.updateList.bind(this);
    this.updateComments = this.updateComments.bind(this);
    this.updateSummaryComments = this.updateSummaryComments.bind(this);
  }

  update(queue) {
    this.props.onUpdate(this.storeKey, {
      List: this.props.List,
      Comments: this.props.Comments,
      SummaryComments: this.props.SummaryComments,
      ...queue,
    });
  }

  updateList(collection) {
    this.update({
      List: collection,
    });
  }

  updateComments = (value) => {
    this.update({
      Comments: value,
    });
  };

  updateSummaryComments(value) {
    this.update({
      SummaryComments: value,
    });
  }

  branchComment = () => (
    <Comments
      title={i18n.t('military.foreign.comments')}
      name="Comments"
      attribute="Comments"
      className="optional-comments"
      {...this.props.Comments}
      onUpdate={this.updateComments}
      onError={this.props.onError}
      required={false}
    >
    </Comments>
  );

  render() {
    const { requireForeignMilitaryMaintainsContact, List } = this.props;

    return (
      <div
        className="section-content foreign"
        data-section={MILITARY.key}
        data-subsection={MILITARY_FOREIGN.key}
      >
        <h1 className="section-header">{i18n.t('military.destination.foreign')}</h1>
        <BranchCollection
          {...this.props.List}
          branchName="has_foreign"
          label={i18n.t('military.foreign.para.served')}
          labelSize="h4"
          appendLabel={i18n.t('military.foreign.collection.foreign.appendTitle')}
          appendSize="h4"
          onUpdate={this.updateList} // eslint-disable-line @typescript-eslint/unbound-method
          scrollToBottom={this.props.scrollToBottom}
          required={this.props.required}
          onError={this.handleError} // eslint-disable-line @typescript-eslint/unbound-method
          scrollIntoView={this.props.scrollIntoView}
          attribute="List"
          branchComment={this.branchComment}
        >
          <ForeignService
            name="Item"
            bind
            addressBooks={this.props.addressBooks}
            dispatch={this.props.dispatch}
            defaultState={this.props.defaultState}
            onError={this.handleError} // eslint-disable-line @typescript-eslint/unbound-method
            required={this.props.required}
            scrollIntoView={this.props.scrollIntoView}
            requireMaintainsContact={requireForeignMilitaryMaintainsContact}
            peopleWhoKnowYou={this.props.peopleWhoKnowYou}
          />
        </BranchCollection>
        {List?.items?.[0]?.Item?.Has?.value === 'Yes' && (
          <Comments
            title={i18n.t('military.foreign.summarycomments')}
            name="SummaryComments"
            attribute="SummaryComments"
            className="summary-comments"
            {...this.props.SummaryComments}
            onUpdate={this.updateSummaryComments}
            onError={this.props.onError}
            required={false}
          >
          </Comments>
        )}
      </div>
    );
  }
}

Foreign.defaultProps = {
  onUpdate: () => { },
  onError: (value, arr) => arr,
  section: 'military',
  subsection: 'foreign',
  addressBooks: {},
  Comments: {},
  SummaryComments: {},
  dispatch: () => { },
  defaultState: true,
  requireForeignMilitaryMaintainsContact: true,
  errors: [],
};

export default connectSubsection(Foreign, sectionConfig);
